import { MonthlyPeriod, MonthlyVolumeKpis } from '../traffic-history.models';
import { bpsToMbps, formatLimaMonthLabel, roundOrNull } from './traffic-format.util';

export function deriveMonthlyVolumeKpis(
  periods: MonthlyPeriod[],
  currentMonth: string,
): MonthlyVolumeKpis | null {
  const target = periods.find((period) => period.month === currentMonth) ?? null;
  if (target === null) {
    return null;
  }

  const monthLabel = formatLimaMonthLabel(target.month);
  const isOpenPeriod = target.periodStatus === 'PARTIAL';
  const volumeStatus = target.volumeStatus ?? null;
  const totalBytes = target.totalBytes ?? null;

  return {
    month: target.month,
    periodStatus: target.periodStatus,
    volumeStatus,
    periodLabel: isOpenPeriod ? `${monthLabel} · mes en curso` : monthLabel,
    downloadBytes: target.downloadBytes ?? null,
    uploadBytes: target.uploadBytes ?? null,
    totalBytes,
    isVolumePartial: volumeStatus !== 'COMPLETE',
    downloadMaxMbps: roundOrNull(bpsToMbps(target.metrics?.download?.maxBps ?? null)),
    uploadMaxMbps: roundOrNull(bpsToMbps(target.metrics?.upload?.maxBps ?? null)),
  };
}

export function availabilityPlaceholder(): { percent: number; caption: string } {
  return {
    percent: 100,
    caption: 'Sin incidencias registradas',
  };
}
